import { PersonStatusEnum, } from "../types/Api";
import { RoleEnum } from "../types/RoleEnum";
import { getStatusTranslation } from "./getStatusTranslation";
import { hasRole } from "./permissionsUtils";
import { DUMMY_SOURCE_ID } from "./personAuthorityLink";
/** "Původ návrhu" value: a person proposed by a publisher (proposer set). */
export var PROPOSAL_ORIGIN_PUBLISHER = "PUBLISHER";
/**
 * "Původ návrhu" value: an import placeholder from the publication records
 * ("blíže neurčená osoba") — the {@link DUMMY_SOURCE_ID} placeholder and no proposer.
 */
export var PROPOSAL_ORIGIN_IMPORT = "IMPORT";
/** URL / filter-state key and CQL index of the "Původ návrhu" register filter. */
export var PROPOSAL_ORIGIN_PARAM = "proposalOrigin";
/**
 * The "Původ návrhu" filter is an agency work tool: only an agency worker (or a
 * superuser, whom hasRole lets through) is offered it, and for anybody else a
 * proposalOrigin URL parameter is dropped — the same gate as the SEARCH_FAILED
 * status (DB-899).
 *
 * @param activeRoles the user's roles; undefined while they are loading
 * @returns whether the user may filter by the proposal origin
 */
export var canFilterProposalOrigin = function (activeRoles) { return !!activeRoles && !!hasRole(activeRoles, RoleEnum.AGENCY_WORKER); };
/**
 * Where the person record comes from, by the same rule as the backend
 * `proposalOrigin` CQL index (and Person.isImportPlaceholder), so a filtered
 * list never shows another origin than the one it was filtered by (DB-899).
 *
 * @param person the person (sourceId, proposer and proposerId are read)
 * @returns PUBLISHER, IMPORT, or undefined for a person of neither origin
 *   (e.g. created by the agency, or an NK authority without a proposer)
 */
export var getPersonProposalOrigin = function (person) {
    if (!person)
        return undefined;
    if (person.proposer != null || person.proposerId != null)
        return PROPOSAL_ORIGIN_PUBLISHER;
    return person.sourceId === DUMMY_SOURCE_ID
        ? PROPOSAL_ORIGIN_IMPORT
        : undefined;
};
/**
 * Keeps only a known filter value (e.g. from a shared URL); anything else
 * means "no filter".
 *
 * @param value the raw value
 * @returns "PUBLISHER", "IMPORT" or ""
 */
export var sanitizeProposalOrigin = function (value) {
    return value === PROPOSAL_ORIGIN_PUBLISHER || value === PROPOSAL_ORIGIN_IMPORT
        ? value
        : "";
};
/**
 * CQL clause of the "Původ návrhu" filter (`proposalOrigin==IMPORT`); the
 * backend reads the unquoted term, like `authorityLinked`.
 *
 * @param value the filter value
 * @returns the clause, or null when the filter is unset
 */
export var buildProposalOriginClause = function (value) {
    var sanitized = sanitizeProposalOrigin(value);
    return sanitized ? "".concat(PROPOSAL_ORIGIN_PARAM, "==").concat(sanitized) : null;
};
/**
 * Text of the "Stav" column of the person registers: a proposal names its
 * origin ("Návrh nakladatele" / "Návrh – blíže neurčená osoba"), every other
 * status is shown unchanged.
 *
 * @param intl react-intl
 * @param person the listed person
 * @returns the status text, "" without a status
 */
export var getPersonStatusLabel = function (intl, person) {
    if (!(person === null || person === void 0 ? void 0 : person.status))
        return "";
    var origin = person.status === PersonStatusEnum.PROPOSAL
        ? getPersonProposalOrigin(person)
        : undefined;
    return origin
        ? intl.formatMessage({
            id: "ui-br-agency.person.status.PROPOSAL.".concat(origin),
        })
        : getStatusTranslation(intl, person.status);
};
